import { Loader } from 'components/Loader';
import { withScheduleMachineStateV3 } from 'domains/signupv3/schedule/context';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

type Props = {
  setIsLoading?: React.Dispatch<React.SetStateAction<boolean>>;
  selectedDate?: string;
};

// This component is used to show a loading spinner while the available evaluation dates are being fetched.
const Loading: React.FC<Props> = ({ selectedDate, setIsLoading }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (!setIsLoading) return;

    setIsLoading(true);

    return () => {
      setIsLoading(false);
    };
  }, []);

  return (
    <div className="-mt-40 h-96 flex items-center justify-center flex-1 gap-8 text-black-38%">
      <Loader />
      <span className="text-sm font-semibold">{t('schedule.confirm.loadingTimesFor', { date: selectedDate })}</span>
    </div>
  );
};

export const ScheduleV3InternalLoadingStep = withScheduleMachineStateV3(Loading, 'loadingAvailableEvalDates');
